import { useMutation, useQueryClient } from '@tanstack/react-query';
import { auth } from '../config/firebase';

export const useAccountDisconnect = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (accountId: string) => {
      const token = await auth.currentUser?.getIdToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await fetch(`https://api.socialness.ai/management/accounts/${accountId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to disconnect account');
      }

      return response.json();
    },
    onSuccess: () => {
      // Invalidate and refetch accounts query
      queryClient.invalidateQueries({ queryKey: ['accounts'] });
    }
  });
};

export const useAccountUnlink = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ accountId, pageId }: { accountId: string; pageId: string }) => {
      const token = await auth.currentUser?.getIdToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await fetch('https://api.socialness.ai/management/accounts/unlink', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          accountId,
          pageId
        })
      });

      if (!response.ok) {
        throw new Error('Failed to unlink account from brand');
      }

      return response.json();
    },
    onSuccess: () => {
      // Invalidate and refetch accounts query
      queryClient.invalidateQueries({ queryKey: ['accounts'] });
    }
  });
};
export const useAccountLinkToBrand = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ accountId, pageId, brandId }: { accountId: string; pageId: string; brandId: string }) => {
      const token = await auth.currentUser?.getIdToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await fetch('https://api.socialness.ai/management/accounts/link', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          accountId,
          pageId,
          brandId
        })
      });

      if (!response.ok) {
        throw new Error('Failed to link account to brand');
      }

      return response.json();
    },
    onSuccess: () => {
      // Invalidate and refetch accounts query
      queryClient.invalidateQueries({ queryKey: ['accounts'] });
    }
  });
};